import React from "react";
import { FaEye } from "react-icons/fa";

const getStatusLabel = (status) => {
  switch (status) {
    case "accepted":
      return "Accepted";
    case "rejected":
      return "Rejected";
    default:
      return "Pending";
  }
};

const MyApplicationsTableView = ({
  applications,
  formatDate,
  getStatusColor,
  onViewDetails,
  onViewRejection,
  normalizeProposedRate,
  getCompanyName,
}) => {
  if (applications.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px]">
        <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Campaign
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Company
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Requirement
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Applied Date
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Proposed Rate
              </th>
              <th className="px-4 lg:px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                Status
              </th>
              <th className="px-4 lg:px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                View
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {applications.map((application) => {
              const rate = normalizeProposedRate(application.proposedRate);
              const rateStr = rate
                ? `${rate.symbol || ""} ${rate.amount} ${rate.code || ""}`.trim()
                : "Not shared";
              return (
                <tr
                  key={application._id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 lg:px-6 py-4">
                    <div className="text-sm font-semibold text-gray-900 truncate">
                      {application.campaignId?.name || "Campaign"}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {application.campaignAdvertisingId?.hireType || "—"}
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {getCompanyName(application)}
                  </td>
                  <td className="px-4 lg:px-6 py-4 min-w-0 max-w-xs">
                    <p className="text-sm text-gray-700 line-clamp-2">
                      {application.campaignAdvertisingId?.requirement || "N/A"}
                    </p>
                  </td>
                  <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {formatDate(application.createdAt)}
                  </td>
                  <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {rateStr}
                  </td>
                  <td className="px-4 lg:px-6 py-4 whitespace-nowrap">
                    <button
                      type="button"
                      onClick={() =>
                        application.status === "rejected" &&
                        onViewRejection(application)
                      }
                      className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusColor(
                        application.status
                      )} ${application.status === "rejected" ? "hover:opacity-80 cursor-pointer" : "cursor-default"}`}
                    >
                      {getStatusLabel(application.status)}
                    </button>
                  </td>
                  <td className="px-4 lg:px-6 py-4 whitespace-nowrap text-center">
                    <button
                      type="button"
                      onClick={() => onViewDetails(application)}
                      className="inline-flex items-center px-3 lg:px-4 py-2 text-sm font-medium text-orange-600 hover:text-orange-700 hover:bg-orange-50 rounded-lg transition-colors"
                    >
                      <FaEye className="mr-1 lg:mr-2" />
                      <span className="hidden lg:inline">View</span>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyApplicationsTableView;